// Max threshold for the number of API V2 tokens that can be created per site.
// This is to prevent abuse of the API V2 token feature.
export const MAX_API_V2_TOKENS_PER_SITE = 20;
